/* eslint jsx-a11y/click-events-have-key-events:0, jsx-a11y/no-static-element-interactions: 0, jsx-a11y/no-noninteractive-element-interactions: 0 */
import clsx from 'clsx'
import { FileRejection, useDropzone } from 'react-dropzone'
import Icon from 'src/components/icons/icon'
import notify from 'src/utils/notify'

export type CsvFileInputProps = {
  name: string
  field: any
  maxFileSize: number
  rules: any
  onFileAdd?: (file: File) => void
  paddingYClass?: string
}

export const CsvFileInput = ({
  name,
  field,
  maxFileSize,
  rules,
  onFileAdd,
  paddingYClass = 'py-10',
}: CsvFileInputProps) => {
  const uploadedFile = field.state.value
  const error = field.state.meta.errors?.at(0)

  const onDrop = async (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
    if (rejectedFiles.length > 0) {
      notify.error(`Unable to upload file. ${rejectedFiles[0]?.errors?.[0].message ?? ''}`)
    }
    if (onFileAdd) {
      await onFileAdd(acceptedFiles[0])
    }
    field.handleChange(acceptedFiles[0])
  }

  const modalDropzone = useDropzone({
    maxSize: maxFileSize,
    onDrop: onDrop,
    maxFiles: 1,
    accept: 'text/csv',
  })

  return (
    <div className='flex flex-grow flex-col'>
      <div
        {...modalDropzone.getRootProps()}
        className={clsx(
          `border-tintDark bg-tintLight hover:bg-tint flex flex-grow cursor-pointer items-center justify-center rounded-lg border-2 border-dashed ${paddingYClass}`,
          error && 'border-error-5',
        )}
      >
        <div className='flex flex-col items-center'>
          <div className='my-4'>
            <img src='/images/upload-cloud.svg' alt='Upload file' className='text-error-5' />
          </div>
          <input {...modalDropzone.getInputProps()} id={name} name={name} />
          <label
            htmlFor={name}
            className='mb-4 text-center'
            onClick={(e) => e.stopPropagation()} // prevent the file dialog from opening twice
          >
            Drag and drop your .csv file here, or
          </label>
          <label
            htmlFor={name}
            className={clsx(
              'cursor-pointer rounded-lg px-3 py-2 text-sm font-bold text-white shadow-sm',
              !error && 'bg-brand hover:brandLight',
              error && 'bg-red-600 hover:bg-red-500',
            )}
            onClick={(e) => e.stopPropagation()} // prevent the file dialog from opening twice
          >
            Upload file
          </label>
          {uploadedFile && (
            <div className='mt-4 flex gap-2'>
              <span className='text-light text-sm'>File attached:</span>
              <span className='text-dark text-sm'>{uploadedFile.name}</span>
            </div>
          )}
        </div>
      </div>
      {error && (
        <div className='flex gap-1 py-1 text-xs'>
          <Icon name='error' size='xs' className='' />
          {error}
        </div>
      )}
    </div>
  )
}
